import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { FlowRemoteDatabaseService } from './flow-remote-database.service';
import { RemoteDatabaseConnectionService } from './remote-database-connection.service';
import { RemoteDatabase } from '../models/Database/remote-database.model';
import { FlowAccountService } from './flow-account.service';
import { RemoteDatabaseRefreshToken } from '@shared/Models/Workflow/remote-database-refresh-token.model';
@Injectable()
export class RemoteDatabaseGuardService  {
	databases: RemoteDatabaseRefreshToken [];
	// databasesToLogin : RemoteDatabaseRefreshToken [] = [];
	constructor(public router: Router, private toastr: ToastrService, private remoteDbService: FlowRemoteDatabaseService, private accountService : FlowAccountService, private databaseConnectionService:RemoteDatabaseConnectionService) { }
	canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | boolean | UrlTree {
		// let tenantParams = route.paramMap.get('tenant');
		// //let tenants = JSON.parse(localStorage.getItem('tenants'));
	    //    return this.remoteDbService.getDatabaseConnections(tenantParams).pipe(map((response) => {
		// 	this.databases = response as RemoteDatabaseRefreshToken[];
		// 	// this.databaseConnectionService.remoteDatabaseSubject.next(this.databases);
		// 	// if(this.databases.some(db => db.Authenticated == false)){
		// 	// 	let tenant = route.paramMap.get('tenant'); 
		// 	// 	this.router.navigate([`${tenant}/remoteconnect`]);
		// 	// 	return false;
		// 	// } else{
		// 		localStorage.setItem('remoteDatabases', JSON.stringify(this.databases));
		// 		return true;				
		// 	//}
		// }));
		//retreive remote database		
		let databases = JSON.parse(localStorage.getItem('remoteDatabasesSettings'));
		this.accountService.saveRemoteDatabaseTokens(databases);
			
		return
	}
	refreshTokenExpired(expirationDate:Date){
		var dt= new Date(expirationDate).getTime();
		var ct= new Date().getTime() + 3000000000;
		return dt < ct;
	}
}